import { Flex, List, Loader, Text, useMantineTheme } from "@mantine/core";
import { useContext, useEffect } from "react";
import { FiExternalLink } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { AppContext } from "src/api/AppContext";
import { useGetCreditAllotmentManyLazyQuery } from "src/generated/graphql";
import { CLIENT_ROUTES, ClientCardBg } from "src/utils/constants";

const MyAccount = () => {
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { currentClient } = useContext(AppContext);

  const [getCredits, { data: creditsData, loading }] =
    useGetCreditAllotmentManyLazyQuery({
      variables: {
        clientId: currentClient?.id || "",
      },
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    if (currentClient) {
      getCredits();
    }
  }, [currentClient]);

  return (
    <Flex
      direction={"column"}
      w={"100%"}
      mah={430}
      my={20}
      px={10}
      bg={ClientCardBg}
      style={{ borderRadius: "10px" }}
    >
      <Flex w={"100%"} justify={"space-between"} align={"center"} py={15}>
        <Text size={18} fw={500}>
          My Account
        </Text>
        <FiExternalLink
          size={20}
          onClick={() => navigate(`/${CLIENT_ROUTES.MY_ACCOUNTS}`)}
        />
      </Flex>
      <Text
        my={10}
        p={10}
        size={14}
        fw={600}
        style={{ borderRadius: "5px" }}
        bg={theme.colors.primary[6]}
        color={theme.colors.primaryTextColor[6]}
      >
        Credits
      </Text>

      <List
        my={10}
        h={"auto"}
        styles={{
          root: {
            height: "auto",
            overflowY: "auto",
          },
          itemWrapper: {
            width: "100%",
          },
          item: {
            width: "98%",
            listStyle: "none",
            cursor: "pointer",
            border: `1px solid black`,
            borderRadius: "5px",
            padding: "5px 10px",
            bg: theme.colors.primary[6],
            color: theme.colors.primaryTextColor[6],
          },
        }}
      >
        {!loading && creditsData?.creditAllotmentMany ? (
          creditsData?.creditAllotmentMany?.map((credit: any) => {
            return (
              <List.Item
                key={credit.id}
                my={10}
                py={10}
                style={{
                  backgroundColor: theme.colors.primary[6],
                  color: theme.colors.primaryTextColor[6],
                  border: "none",
                }}
              >
                <Flex align={"center"} justify={"space-between"}>
                  <Text size={14} fw={500}>
                    {credit.name}
                  </Text>
                  <Text size={14} fw={400}>
                    {credit.credits} Available
                  </Text>
                </Flex>
              </List.Item>
            );
          })
        ) : (
          <Loader />
        )}
      </List>
    </Flex>
  );
};

export default MyAccount;
